import A11yDialog from "a11y-dialog";

document.addEventListener("DOMContentLoaded", () => {
    if (typeof jQuery === "undefined") return;
    const $ = jQuery;

    const basketPageBody                        = document.querySelector('body.woocommerce-cart');
    const isBasketPage                          = !!basketPageBody;

    const courseListingResults                  = document.getElementById("course-listing-results");
    const isCourseListingResults                = !!courseListingResults;

    const courseModalElement                    = document.getElementById("course-modal");
    const hasCourseModal                        = !!courseModalElement;

    const courseAddedModalElement               = document.getElementById("course-added-modal");
    const hasCourseAddedModal                   = !!courseAddedModalElement;

    // Course Modal (CM)
    const courseModal                           = hasCourseModal ? new A11yDialog(courseModalElement) : null;
    const courseModalImageElement               = hasCourseModal ? document.getElementById("course-modal-image") : null;
    const courseModalTitleElement               = hasCourseModal ? document.getElementById("course-modal-title") : null;
    const courseModalAddtoCartElem              = hasCourseModal ? document.getElementById("course-modal-add-to-cart") : null;
    const courseModalPriceWrapElement           = hasCourseModal ? document.getElementById("course-modal-date") : null; // Yes, it's named that
    const courseModalQtyWrapElement             = hasCourseModal ? document.querySelector(".course-modal-quantity") : null;
    const courseModalSuitabilityWrapElement     = hasCourseModal ? document.querySelector(".course-modal-suitability") : null;
    const $courseModalSelectCourseInstance      = hasCourseModal ? $("#selectDateModal") : null;

    const courseModalIconsElement               = hasCourseModal ? document.getElementById("course-modal-icons") : null;
    const cmIconQualification                   = hasCourseModal ? courseModalIconsElement.querySelector(".qualification") : null;
    const cmIconLocation                        = hasCourseModal ? courseModalIconsElement.querySelector(".location") : null;
    const cmIconDate                            = hasCourseModal ? courseModalIconsElement.querySelector(".date") : null;


    // Course Added Modal (CAM)
    const courseAddedModal                      = hasCourseAddedModal ? new A11yDialog(courseAddedModalElement) : null;
    const courseAddedModalFragmentElement       = document.getElementById("course-added-modal-fragment");
    const talentLmsButton                       = $('.talent-lms-course-modal-button');


    const otherCoursesSliderOptions = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                },
            },
        ],
    };




    /** ---------- Product Cards ---------- */

    /**
     * Product cards: Add to Basket buttons
     */
    if (hasCourseModal) {

        if (isBasketPage) {

            basketPageBody.addEventListener("click", async (e) => {

                const target = e.target;

                if (target.classList.contains("course-modal-button")) {

                    e.preventDefault();
                    const courseId = target.dataset.id;

                    try {

                        loadCourseModal(courseId);

                    } catch (error) {
                        resetCourseModal();
                        courseModalTitleElement.innerHTML = 'Error loading course data';
                        courseModalImageElement.innerHTML = '';

                        console.log('Error loading course data', error, courseId);
                    }
                }
            });

        } else if (isCourseListingResults) {

            // Course archive page cards

            courseListingResults.addEventListener("click", async (e) => {

                const target = e.target;

                if (target.classList.contains("course-modal-button")) {

                    e.preventDefault();
                    const courseId = target.dataset.id;

                    try {

                        loadCourseModal(courseId);

                    } catch (error) {
                        resetCourseModal();
                        courseModalTitleElement.innerHTML = 'Error loading course data';
                        courseModalImageElement.innerHTML = '';

                        console.log('Error loading course data', error, courseId);
                    }
                }
            });

        }

    }





    /** ---------- Course Modal ---------- */

    let loadCourseModal = null;

    if (hasCourseModal) {

        /**
         * Course Modal: Load and open the modal for the given course ID
         */
        loadCourseModal = async (courseId) => {

            resetCourseAddedModal();
            hideCourseAddedModal();

            resetCourseModal();
            courseModal.show();

            courseModalElement.setAttribute("data-course-id", courseId);

            const response = await fetchProductData(courseId);
            const instances = response?.data?.instances || [];

            courseModalTitleElement.innerHTML = response.data.title;

            const courseImage = response?.data?.images[0] || "";
            const courseImageHTML = courseImage
                ? `<img src="${courseImage.src}" alt="${courseImage.alt || ""}">`
                : "";
            courseModalImageElement.innerHTML = courseImageHTML;

            const suitability = response?.data?.suitability || "";

            if (suitability.length) {
                courseModalSuitabilityWrapElement.style.display = '';
                courseModalSuitabilityWrapElement.querySelector(".course-modal-suitability-description").innerText = suitability;
            }

            const qualifications = response?.data?.qualifications || "";
            if (qualifications) {
                cmIconQualification.querySelector(".value").innerText = qualifications;
                cmIconQualification.style.display = 'flex';
            }

            const location = response?.data?.location || "";
            if (location) {
                cmIconLocation.querySelector(".value").innerText = location;
                cmIconLocation.style.display = 'flex';
            }

            const date = response?.data?.date || "";
            if (date) {
                cmIconDate.querySelector(".value").innerText = date;
                cmIconDate.style.display = 'flex';
            }

            // Set the initial prices against the parent product data
            let price = response?.data?.price || "";
            let regularPrice = response?.data?.regular_price || "";
            let priceSuffix = response?.data?.price_suffix || "";

            if (price == regularPrice) {
                regularPrice = "";
            }

            updateCourseModalPriceTexts(price, regularPrice, priceSuffix);

            if (instances.length >= 1) {
                initCourseModalSelect2(instances, "Choose date...");
                toggleCourseModalElements(true, true);

                // If a single option is available, select it immediately
                if (instances.length == 2) {
                    // ("Choose date..." + single date choice) = 2 options

                    $courseModalSelectCourseInstance.val(instances[1].id).trigger({
                        type: 'select2:select',
                        params: {
                            data: instances[1],
                        },
                    });

                }

                updateSelect2Quantity();

            } else {
                initCourseModalSelect2([], 'No dates available.');
                toggleCourseModalElements(false, true);

                courseModalAddtoCartElem.setAttribute("aria-disabled", true);
            }

            courseModalElement.classList.remove('__loading');
        }

        window.loadCourseModal = loadCourseModal;


        /**
         * Course Modal: Add to basket button click
         */
        courseModalAddtoCartElem.addEventListener("click", (e) => {
            e.preventDefault();

            const target = e.target;

            // Button still clickable in disabled state?
            if (target.disabled || target.getAttribute('aria-disabled') === 'true') {
                e.stopPropagation();
                return;
            }

            const $this = $(this);

            // Disable the CM form elements
            toggleCourseModalElements(false, false);
            courseModalAddtoCartElem.setAttribute("aria-disabled", true);

            const $selected = $courseModalSelectCourseInstance.find(":selected");

            const courseId = parseInt(courseModalElement.dataset.courseId || 0) || 0;
            const courseInstanceId = parseInt(courseModalElement.dataset.courseInstanceId || 0) || 0;
            const qty = parseInt(courseModalQtyWrapElement.querySelector("input[type=number]").value, 10) || 1;
            const startDate = $selected.data("start-date") || "";
            const location = cmIconLocation.querySelector(".value").innerText || "";

            addCourseInstanceToCartAjax(courseId, qty, courseInstanceId)
                .then(function(response) {

                    courseModal.hide();
                    showCourseAddedModal();

                    initOrRecalcOtherCourses();
                })
                .fail(function(response) {
                    alert('Sorry, something went wrong adding the course to your basket.');
                    console.log("Unable to add course to basket", courseId, courseInstanceId, qty);
                });
        });

        talentLmsButton.on("click", (e) => {
            e.preventDefault();
            const $this = $(this);
            const target = e.target;
            const courseId = parseInt(target.dataset.courseId || 0);
            const qty = 1;

            addTalentLMSToCartAjax(courseId, qty)
            .then(function(response) {

                showCourseAddedModal();

                initOrRecalcOtherCourses();
            });
        });


        /**
         * Course Modal: User manually types a number into the input box
         */
        courseModalQtyWrapElement.querySelector("input[type=number]").addEventListener("change", (e) => {
            updateSelect2Quantity();
        });


        /**
         * Course Modal: Course instance select box selection
         */
        $courseModalSelectCourseInstance.on("select2:select", (e) => {
            const $this = $(e.target);
            const data = e.params.data;
            const dataset = data?.element?.dataset;

            if (data?.id && data.id > 0) {
                // Enable the cart button if a valid option is chosen
                // It may be re-disabled by the quantity check though
                courseModalAddtoCartElem.setAttribute("aria-disabled", false);
                courseModalElement.setAttribute("data-course-instance-id", data.id);

                // Ensure we update the price display, as individual instances can have differeng prices
                let price = dataset?.price || "";
                let regularPrice = dataset?.regularPrice || "";
                let priceSuffix = dataset?.priceSuffix || "";

                if (price == regularPrice) {
                    regularPrice = "";
                }

                if (price) {
                    updateCourseModalPriceTexts(price, regularPrice, priceSuffix);
                }
            }
        });


        /**
         * Course Modal: Reset back to 'loading' state
         */
        const resetCourseModal = () => {
            courseModalElement.classList.add("__loading");

            // Data attributes
            courseModalElement.setAttribute("data-course-id", 0);
            courseModalElement.setAttribute("data-course-instance-id", 0);
            courseModalElement.setAttribute("data-qty", 1);
            courseModalElement.setAttribute("data-course-price-text", "&pound;0");

            // Title
            courseModalTitleElement.innerHTML = 'Loading course dates...';

            // Image
            courseModalImageElement.innerHTML = '';

            // Icons
            cmIconQualification.querySelector(".value").innerText = '-';
            cmIconLocation.querySelector(".value").innerText = '-';
            cmIconDate.querySelector(".value").innerText = '-';

            cmIconQualification.style.display = 'none';
            cmIconLocation.style.display = 'none';
            cmIconDate.style.display = 'none';

            // Disable quantity + select
            toggleCourseModalElements(false, true);
            initCourseModalSelect2([], 'Loading course dates...');

            // Hide the suitability text
            courseModalSuitabilityWrapElement.style.setProperty("display", "none", "important");

            // Disable basket button
            courseModalAddtoCartElem.setAttribute("aria-disabled", true);

            // Price label
            updateCourseModalPriceTexts();
        }


        /**
         * Course Modal: Helper to update the prices (sale + regular + suffix)
         */
        const updateCourseModalPriceTexts = (priceText, saleText, priceSuffix) => {
            if (!courseModalPriceWrapElement) return;

            const hasText = v => typeof v === "string" && v.trim() !== "";

            if (!hasText(priceText) && !hasText(saleText)) {
                courseModalPriceWrapElement.innerHTML = "";
                courseModalPriceWrapElement.style.display = "none";
                return;
            }

            const spans = [];

            // Sale text
            if (hasText(saleText)) {
                const spanSale = document.createElement("span");
                spanSale.className = "course-modal-date-item __sale";
                spanSale.innerHTML = saleText;
                spans.push(spanSale);
            }

            // Regular price + suffix
            if (hasText(priceText)) {
                const spanPrice = document.createElement("span");
                spanPrice.className = "course-modal-date-item";
                spanPrice.innerHTML = hasText(priceSuffix) ? `${priceText} ${priceSuffix}` : priceText;
                spans.push(spanPrice);
            }

            courseModalPriceWrapElement.replaceChildren(...spans);
            courseModalPriceWrapElement.style.display = "flex";

            courseModalElement.setAttribute("data-course-price-text", priceText);
        };


        /**
         * Course Modal: Initialise or reset the select2 options
         */
        const initCourseModalSelect2 = (options, initialOptionLabel = null) => {

            // Workaround select2 placeholder/allowClear not working as expected
            if (initialOptionLabel) {
                const initialOption = {
                    id: "",
                    text: initialOptionLabel,
                }

                options.unshift(initialOption);
            }

            const selectProps = {
                containerCssClass: "select2-css",
                minimumResultsForSearch: Infinity,
                dropdownParent: $courseModalSelectCourseInstance.parent(),
                width: '100%',
            };

            if ($courseModalSelectCourseInstance.hasClass("select2-hidden-accessible")) {
                $courseModalSelectCourseInstance.select2("destroy");
            }

            $courseModalSelectCourseInstance.empty();

            options.forEach((item, index) => {
                const available = item?.available || 0;
                const startDate = item?.start_date || "";
                const price = item?.price || "";
                const regularPrice = item?.regular_price || "";
                const priceSuffix = item?.price_suffix || "";
                const isOnSale = item?.is_on_sale || false;

                const option = new Option(item.text, item.id, false, false);
                option.setAttribute("data-available", available);
                option.setAttribute("data-start-date", startDate);
                option.setAttribute("data-price", price);
                option.setAttribute("data-regular-price", regularPrice);
                option.setAttribute("data-price-suffix", priceSuffix);
                option.setAttribute("data-is-on-sale", isOnSale);

                $courseModalSelectCourseInstance.append(option);

            });

            $courseModalSelectCourseInstance.select2(selectProps);
        }


        /**
         * Course Modal: Update the select2 options disabled state based on the quantity spinner
         */
        const updateSelect2Quantity = () => {
            const qty = parseInt(courseModalQtyWrapElement.querySelector("input[type=number]").value, 10) || 0;

            courseModalElement.setAttribute("data-qty", qty);

            $courseModalSelectCourseInstance.find("option").each(function () {
                const $this = $(this);
                const available = parseInt($this.data("available"), 10) || 0;

                $this.prop("disabled", available < qty);
            });

            // If the selected option became disabled, clear selection
            const $selected = $courseModalSelectCourseInstance.find(":selected");
            if ($selected.length && $selected.prop("disabled")) {
                $courseModalSelectCourseInstance.val(null).trigger("change");
                courseModalAddtoCartElem.setAttribute("aria-disabled", true);
                courseModalElement.setAttribute("data-course-instance-id", 0);
            }

            // Refresh Select2 rendering after disabling options
            $courseModalSelectCourseInstance.trigger("change.select2");
        }



        /**
         * Course Modal: Handle the quantity spinner minus button
         */
        const decrementCourseModalQuantity = (target) => {
            decrementQuantity(target);
            updateSelect2Quantity()
        }

        window.decrementCourseModalQuantity = decrementCourseModalQuantity


        /**
         * Course Modal: Handle the quantity spinner plus button
         */
        const incrementCourseModalQuantity = (target) => {
            incrementQuantity(target);
            updateSelect2Quantity()
        }

        window.incrementCourseModalQuantity = incrementCourseModalQuantity

    }


    /**
     * Course Modal: Toggle the form elements on/off
     */
    const toggleCourseModalElements = (enabled = true, resetQty = true) => {

        if (!hasCourseModal) {
            return;
        }

        // Quantity spinner
        const minusElem = courseModalQtyWrapElement.querySelector(".minus");
        const plusElem = courseModalQtyWrapElement.querySelector(".plus");
        const inputElem = courseModalQtyWrapElement.querySelector("input[type=number]");

        minusElem.disabled = !enabled;
        plusElem.disabled = !enabled;

        inputElem.disabled = !enabled;

        if (resetQty) {
            inputElem.value = 1;
            inputElem.max = enabled ? 99 : 1;
        }

        // Select box
        $courseModalSelectCourseInstance.prop("disabled", !enabled);
    }


    /** ---------- Course Added Modal ---------- */

    if (hasCourseAddedModal) {

        document.addEventListener("click", async (e) => {

            const target = e.target;

            const closeTrigger = typeof target.closest === "function" ? target.closest('[data-a11y-dialog-hide="course-added-modal"]') : null;

            if (closeTrigger && courseAddedModalElement.contains(closeTrigger)) {
                e.preventDefault();
                hideCourseAddedModal();
                return;
            }

            // "Edit date" / "Edit Quantity" links
            if (target.classList.contains("course-added-modal-edit-item-link")) {
                // Re-grab the element as it doesn't seem to have updated otherwise
                const elem = document.getElementById("course-added-modal-fragment");

                const removeKey = elem.dataset.removeKey || "";
                const courseId = elem.dataset.courseId || "";

                // We won't wait for the AJAX promise to complete, just hide/show the dialogs...
                removeFromCartAjax(removeKey);

                hideCourseAddedModal();

                if (!hasCourseModal) {
                    return;
                }

                /**
                 * The modal isn't initialised on single course pages unless
                 * the user clicks one of the 'edit' links (as we bypass directly to the 2nd modal)
                 * so in such cases, we need to init the modal from scratch
                 */
                if (courseId && typeof loadCourseModal === "function") {
                    loadCourseModal(courseId);
                } else {
                    courseModal.show();
                    toggleCourseModalElements(true, false);
                    courseModalAddtoCartElem.setAttribute("aria-disabled", false);
                }
            }

            // Related Product "Add to basket" links
            if (target.classList.contains("course-added-modal-related-basket-link")) {
                const courseId = target.dataset.id || 0;

                if (courseId && typeof loadCourseModal === "function") {
                    loadCourseModal(courseId);
                }
            }
        });

    }

    /** CAM: Reset the related course slick slider */
    const initOrRecalcOtherCourses = ($scope) => {

        const $sliders = $scope ? $scope.find(".other-courses-slider") : $(".other-courses-slider");
        $sliders.each(function () {
            const $el = $(this);
            if ($el.hasClass("slick-initialized")) {
                $el.slick("setPosition");
            } else if ($.fn && $.fn.slick) {
                $el.slick(otherCoursesSliderOptions);
            }
        });
    };

    initOrRecalcOtherCourses();


    /** CAM: Show the modal if available */
    const showCourseAddedModal = () => {
        if (courseAddedModal) {
            courseAddedModal.show();

            initOrRecalcOtherCourses();
        }
    };

    window.showCourseAddedModal = showCourseAddedModal;


    /** CAM: Hide the modal if available */
    const hideCourseAddedModal = () => {
        if (courseAddedModal) {
            courseAddedModal.hide();
        }
    };


    /** CAM: Reset contents to blank */
    const resetCourseAddedModal = () => {
        if (courseAddedModalFragmentElement) {
            courseAddedModalFragmentElement.innerHTML = "";
        }
    };


    /**
     * Send AJAX request for course instance dates
     */
    const fetchProductData = async (courseId) => {

        const requestData = new URLSearchParams();
        requestData.append("action", "add_to_cart_modal_data");
        requestData.append("product_id", courseId);

        const response = await fetch("/wp-admin/admin-ajax.php", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: requestData.toString(),
        });

        if (!response?.ok) {
            throw new Error(`HTTP error, status ${response.status}`);
        }

        const json = await response.json();

        return json;
    }


    /**
     * AJAX Add Course Instance to basket
     * Hooks into WooCommerce's native method
     */
    const addCourseInstanceToCartAjax = (courseId, qty, courseInstanceId = 0) => {
        let endpoint = wc_add_to_cart_params?.wc_ajax_url || "";

        if (!endpoint) {
            return;
        }

        endpoint = endpoint.replace('%%endpoint%%', 'add_to_cart');

        const data = {
            product_id: courseId,
            quantity: qty || 1,
            course_instance_id: courseInstanceId,
            course_add_to_cart: 1,
        }

        return $.post(endpoint, data)
            .then(function (resp) {

                if (resp?.error) {
                    // Turn the json error into a promise fail and trigger the .fail()
                    return $.Deferred().reject(resp).promise();
                }

                // Trigger the native basket fragment event
                $(document.body).trigger('added_to_cart', [resp.fragments, resp.cart_hash, null]);
            })
            .fail(function (resp) {
                console.log("Unable to add course to basket", endpoint, data, resp);
            });
    }

    window.addCourseInstanceToCartAjax = addCourseInstanceToCartAjax;

    /**
     * AJAX Add Talent LMS Course to basket
     * Hooks into WooCommerce's native method
     */
    const addTalentLMSToCartAjax = (courseId, qty) => {
        let endpoint = wc_add_to_cart_params?.wc_ajax_url || "";

        if (!endpoint) {
            return;
        }

        endpoint = endpoint.replace('%%endpoint%%', 'add_to_cart');

        const data = {
            product_id: courseId,
            quantity: qty || 1,
            talent_lms_add_to_cart: 1,
        }

        return $.post(endpoint, data).done(function (resp) {

            // Trigger the native basket fragment event
            $(document.body).trigger('added_to_cart', [resp.fragments, resp.cart_hash, null]);
        }).fail(function () {
            console.log("Unable to add course to basket", endpoint, data, resp);
        });
    }

    window.addTalentLMSToCartAjax = addTalentLMSToCartAjax;


    /**
     * AJAX Add Product to basket
     * Hooks into WooCommerce's native method
     */
    const addProductToCartAjax = (courseId, qty) => {
        let endpoint = wc_add_to_cart_params?.wc_ajax_url || "";

        if (!endpoint) {
            return;
        }

        endpoint = endpoint.replace('%%endpoint%%', 'add_to_cart');

        const data = {
            product_id: courseId,
            quantity: qty || 1,
            
            product_sd_add_to_cart: 1,
        }

        return $.post(endpoint, data).done(function (resp) {

            if (resp?.error) {
                // Turn the json error into a promise fail and trigger the .fail()
                return $.Deferred().reject(resp).promise();
            }

            // Trigger the native basket fragment event
            $(document.body).trigger('added_to_cart', [resp.fragments, resp.cart_hash, null]);
        }).fail(function () {
            console.log("Unable to add product to basket", endpoint, data, resp);
        });
    }

    window.addProductToCartAjax = addProductToCartAjax;


    const removeFromCartAjax = (removeKey) => {

        let endpoint = wc_add_to_cart_params?.wc_ajax_url || "";

        if (!endpoint) {
            return;
        }

        endpoint = endpoint.replace('%%endpoint%%', 'remove_from_cart');

        const data = {
            cart_item_key: removeKey,
        }

        return $.post(endpoint, data).done(function (resp) {

            // Trigger the native basket fragment event
            $(document.body).trigger('added_to_cart', [resp.fragments, resp.cart_hash, null]);
        }).fail(function () {
            console.log("Unable to remove course from basket", endpoint, data, resp);
        });
    }

    window.removeFromCartAjax = removeFromCartAjax;

});


/**
 * Capture all generic /cart/add-to-cart links and feed them into the AJAX handler
 */
$(function ($) {
    $(document).on('click', 'a[href*="/cart/?add-to-cart="]', function (e) {
        const href = $(this).attr('href');
        const match = href.match(/[?&]add-to-cart=(\d+)/);

        if (!match) {
            return;
        }

        e.preventDefault();
        const productId = match[1];

        addProductToCartAjax(productId, 1).then(function (resp) {
            showCourseAddedModal();
        })
            .fail(function (resp) {
                alert('Something went wrong trying to add the product to your basket.');
                console.log("Unable to add product to basket", productId);
            });
    });
});
